import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, HospitalIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-120" data-mp="s9zwrat6gujk">
      <div className="h-1.5 w-full bg-gold" aria-hidden="true" data-id="element-121" data-mp="ncq31iyr9wpx" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-122" data-mp="nekmstyajisf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-steel px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-123" data-mp="3czfk1vt6u14g">
          <HospitalIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="39authk0ozz0e" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-white sm:text-5xl lg:text-6xl" data-id="element-125" data-mp="3e8mud3jbevgq">
          Master Your Year of Surgical Instrumentation Education
          <br data-id="element-126" data-mp="2vietyt702j48" />
          <span className="text-mineral" data-id="element-127" data-mp="2vjzq2n8yqa47">in One Afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-128" data-mp="2hinc2hdd4iky">
          <img src={productImage} alt="Surgical Instrumentation Teacher Ready: nine volumes and five bonus resources covering fundamentals, instrument classification, asepsis, perioperative workflow, surgical anatomy, sterilization, specialized instrumentation, operating room management, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-129" data-mp="s3cloaja7jqk" />
        </motion.div>

        <div className="mt-9" data-id="element-130" data-mp="1ayjilhmnxm7u">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-131" data-mp="161aznetoxe5j">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-132" data-mp="110wqtuk9m06g">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-gold/40 bg-steel px-3 py-2" data-id="element-133" data-mp="3lt75ys5mbtus">
              <Icon className="h-3.5 w-3.5 text-mineral" aria-hidden="true" data-id="element-134" data-mp="1x9b42xkwqvaz" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-muted" data-id="element-135" data-mp="21by0lbsix4ei">
          Created by surgical instrumentation education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}